import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { KrakenLogo } from "@/components/PublicLayout";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try { await login(form.email, form.password); nav("/portal"); }
    catch (e) { setErr(e.message); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12 text-white" data-testid="login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-8"><KrakenLogo /></Link>
        <form onSubmit={submit} className="kr-card rounded-2xl p-8 space-y-4" data-testid="login-form">
          <div className="text-center">
            <div className="eyebrow mb-2">Parent / Player Portal</div>
            <h1 className="font-display text-3xl uppercase">Sign In</h1>
          </div>
          <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" data-testid="login-email" />
          <input required type="password" placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" data-testid="login-password" />
          {err && <div className="text-red-400 text-sm" data-testid="login-error">{err}</div>}
          <button disabled={loading} className="btn-primary w-full justify-center" data-testid="login-submit">{loading ? "Signing in..." : "Sign In"}</button>
          <div className="text-center text-sm text-slate-400">
            New to Kraken? <Link to="/register" className="text-[#00E5FF]">Create account</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
